import React, { useState, useEffect } from "react";
import "./QuizActivity.css";

const QuizActivity = ({ question, onAnswer, onPrev, questionIndex = 0, totalQuestions = 0 }) => {
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [shuffledOptions, setShuffledOptions] = useState([]);

  const correctAnswer = question?.answer?.trim() || "";

  const shuffleArray = (array) => {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
  };

  useEffect(() => {
    if (question?.options) {
      setShuffledOptions(shuffleArray(question.options));
      setSelectedAnswer(null);
    }
  }, [question]);

  if (!question) return <p>Loading...</p>;

  const isAnswerCorrect = (answer) => {
    if (!answer || !correctAnswer) return false;
    return answer.trim().toLowerCase() === correctAnswer.trim().toLowerCase();
  };

  const handleAnswerClick = (option) => {
    setSelectedAnswer(option);
  };

  const handleNext = () => {
    const isCorrect = isAnswerCorrect(selectedAnswer);

    if (typeof onAnswer === "function") {
      onAnswer({
        correct: isCorrect,
        next: true,
        selected: selectedAnswer,
      });
    }
    setSelectedAnswer(null);
  };

  const answered = Boolean(selectedAnswer);
  const answeredCorrectly = answered && isAnswerCorrect(selectedAnswer);
  const isLastQuestion = questionIndex === totalQuestions - 1;
  const nextLabel = isLastQuestion && totalQuestions > 0 ? "Finish Quiz →" : "Next Question →";

  return (
    <div className="quizactivity__card">
      {totalQuestions > 0 && (
        <p className="quizactivity__counter">
          Question {questionIndex + 1} of {totalQuestions}
        </p>
      )}

      <h2 className="quizactivity__question">{question.question}</h2>

      <div className="quizactivity__options">
        {shuffledOptions.map((option, index) => {
          let buttonClass = "quizactivity__option-button";
          if (answered) {
            if (option === selectedAnswer) {
              buttonClass += answeredCorrectly ? " correct" : " incorrect";
            }
            if (option === correctAnswer && selectedAnswer !== correctAnswer) {
              buttonClass += " correct";
            }
          }

          return (
            <button
              key={index}
              onClick={() => handleAnswerClick(option)}
              disabled={answered}
              className={buttonClass}
            >
              {option}
            </button>
          );
        })}
      </div>

      {answered && (
        <div className="quizactivity__feedback">
          <p>{answeredCorrectly ? "✅ Correct!" : "❌ Incorrect."}</p>
          {question.context && (
            <div className="quizactivity__solution">
              <p><strong>Explanation:</strong> {question.context}</p>
            </div>
          )}
          <button className="quizactivity__next-btn" onClick={handleNext}>
            {nextLabel}
          </button>
        </div>
      )}

      <div className="quizactivity__nav-footer">
        <button
          className="quizactivity__nav-arrow"
          onClick={onPrev}
          disabled={!onPrev || questionIndex === 0}
          aria-label="Previous Question"
        >
          &#8592;
        </button>

        <button
          className="quizactivity__nav-arrow quizactivity__nav-arrow--next"
          onClick={handleNext}
          aria-label={isLastQuestion ? "Finish Quiz" : "Next Question"}
        >
          &#8594;
        </button>
      </div>
    </div>
  );
};

export default QuizActivity;
